
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-facebook_2"},[_c('path',{staticClass:"i-Vector",attrs:{"d":"M17.25 9a8.25 8.25 0 1 0-9.54 8.15v-5.765H5.617V9h2.095V7.182c0-2.067 1.232-3.21 3.116-3.21.902 0 1.847.162 1.847.162v2.03h-1.04c-1.025 0-1.345.636-1.345 1.29V9h2.288l-.366 2.385H10.29v5.765A8.252 8.252 0 0 0 17.25 9Z","fill":"#798f8f"}})])])
          )
        }
      }
    